import url from './apiUrl'
import handleResponse from './handleResponse'

export default (token, payload) => {

    return fetch(`${url()}/posts/delete`, {
                method: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": token
                },
                body: JSON.stringify(payload)
            })
            .then( res => handleResponse(res))
            .catch( err => console.log(err))

}